import { tv } from "../foundations/cn.js";

/** The dimmed page behind a Modal or ConfirmDialog. */
export const MODAL_BACKDROP =
  "fixed inset-0 z-50 bg-bg-canvas/60 transition-opacity duration-base data-ending-style:opacity-0 data-starting-style:opacity-0 motion-reduce:transition-none";

/** A Modal's or ConfirmDialog's panel: a sheet from the bottom on phones, centered from sm. */
export const modalPopupStyles = tv({
  base: [
    "fixed z-50 flex max-h-[calc(100dvh-32px)] flex-col overflow-hidden border border-border-default bg-bg-surface shadow-float outline-hidden",
    // Phones: a sheet from the bottom edge. From sm: centered.
    "inset-x-0 bottom-0 rounded-t-3xl sm:inset-x-auto sm:bottom-auto sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-3xl",
    "transition-[opacity,translate,scale] duration-base ease-enter data-ending-style:ease-exit motion-reduce:transition-none",
    "data-starting-style:translate-y-8 data-ending-style:translate-y-8 data-starting-style:opacity-0 data-ending-style:opacity-0",
    "sm:data-starting-style:-translate-y-1/2 sm:data-ending-style:-translate-y-1/2 sm:data-starting-style:scale-95 sm:data-ending-style:scale-95",
  ],
  variants: {
    size: {
      sm: "sm:w-[min(400px,calc(100vw-32px))]",
      md: "sm:w-[min(480px,calc(100vw-32px))]",
      lg: "sm:w-[min(640px,calc(100vw-32px))]",
    },
  },
  defaultVariants: { size: "md" },
});
